export const SIGNING_PIN_PERMISSION = "users:manage_signing_pin"
